import ReactDOM from 'react-dom'

function RecordingAudioBackdrop({ zIndex = 10 }: { zIndex?: 10 | 20 | 30 }) {
  return ReactDOM.createPortal(
    <div
      className={`absolute z-${zIndex} left-0 top-0 h-full w-full bg-gradient-to-b from-transparent from-[0%] to-black to-[100%]`}
    />,
    document.body
  )
}

export default RecordingAudioBackdrop
